import React, { createContext, useContext, ReactNode } from 'react';
import { loadStripe, Stripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

// Determine if we're in development mode
const isDevelopment = import.meta.env.DEV;

// Use DEV Stripe key if in development and it exists, otherwise use production key
const stripePublishableKey = (isDevelopment && (import.meta as any).env.VITE_STRIPE_PUBLISHABLE_KEY_DEV) 
  ? (import.meta as any).env.VITE_STRIPE_PUBLISHABLE_KEY_DEV 
  : (import.meta as any).env.VITE_STRIPE_PUBLISHABLE_KEY;

// console.log(`🔗 Stripe Frontend: Using ${isDevelopment && (import.meta as any).env.VITE_STRIPE_PUBLISHABLE_KEY_DEV ? 'TEST' : 'LIVE'} keys`);

// Initialize Stripe
const stripePromise = loadStripe(stripePublishableKey);

interface StripeContextType {
  stripe: Promise<Stripe | null>;
}

const StripeContext = createContext<StripeContextType | undefined>(undefined);

export const useStripe = () => {
  const context = useContext(StripeContext);
  if (context === undefined) {
    throw new Error('useStripe must be used within a StripeProvider');
  }
  return context;
};

interface StripeProviderProps {
  children: ReactNode;
}

export const StripeProvider: React.FC<StripeProviderProps> = ({ children }) => {
  return (
    <StripeContext.Provider value={{ stripe: stripePromise }}>
      <Elements stripe={stripePromise}>
        {children}
      </Elements>
    </StripeContext.Provider>
  );
};

export default StripeProvider;
